module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-lookup-af662077bd2be3f576725994f114d1fe.svg";